module.exports = __webpack_public_path__ + "static/img/6.35c09a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/3/1/zh/6.png
// module id = 2fRI
// module chunks = 0